"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperation = exports.GetOperationSymbol = void 0;
var engine_utils_1 = require("@verified/c11-engine.utils");
var isString_1 = __importDefault(require("lodash/isString"));
var isArray_1 = __importDefault(require("lodash/isArray"));
var getInvokablePath_1 = require("./getInvokablePath");
var isFunction_1 = __importDefault(require("lodash/isFunction"));
// TODO: add a isValid method to be able to check
// if the ref path is properly generated
// TODO: Return a false or error if the path was not generated
exports.GetOperationSymbol = Symbol("get");
var getOperation = function (db, structure, op) {
    var value = function (params) {
        var path = (0, getInvokablePath_1.getInvokablePath)(structure, op, params);
        if (path) {
            return db.get(path);
        }
        return;
    };
    var includes = function (value, params) {
        var path = (0, getInvokablePath_1.getInvokablePath)(structure, op, params);
        if (path) {
            var val = db.get(path);
            if ((0, isArray_1.default)(val) || (0, isString_1.default)(val)) {
                return val.includes(value);
            }
        }
    };
    var length = function (params) {
        var path = (0, getInvokablePath_1.getInvokablePath)(structure, op, params);
        if (path) {
            var val = db.get(path);
            if (!((0, isString_1.default)(val) || (0, isArray_1.default)(val) || (0, isFunction_1.default)(val))) {
                return;
            }
            return val.length;
        }
    };
    var operation = {
        value: value,
        includes: includes,
        length: length,
        __operation__: {
            id: (0, engine_utils_1.randomId)(),
            symbol: exports.GetOperationSymbol,
            path: op.path,
        },
    };
    return operation;
};
exports.getOperation = getOperation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0T3BlcmF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dyYXBoL2dldE9wZXJhdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFNQSxrREFBNkM7QUFDN0MsNkRBQXVDO0FBQ3ZDLDJEQUFxQztBQUNyQyx1REFBc0Q7QUFDdEQsaUVBQTJDO0FBRTNDLGlEQUFpRDtBQUNqRCx3Q0FBd0M7QUFFeEMsOERBQThEO0FBRWpELFFBQUEsa0JBQWtCLEdBQUcsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBRXpDLElBQU0sWUFBWSxHQUFHLFVBQzFCLEVBQXFCLEVBQ3JCLFNBQXlCLEVBQ3pCLEVBQWdCO0lBRWhCLElBQU0sS0FBSyxHQUFHLFVBQUMsTUFBdUI7UUFDcEMsSUFBTSxJQUFJLEdBQUcsSUFBQSxtQ0FBZ0IsRUFBQyxTQUFTLEVBQUUsRUFBRSxFQUFFLE1BQU0sQ0FBQyxDQUFDO1FBQ3JELElBQUksSUFBSSxFQUFFO1lBQ1IsT0FBTyxFQUFFLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQ3JCO1FBQ0QsT0FBTztJQUNULENBQUMsQ0FBQztJQUNGLElBQU0sUUFBUSxHQUFHLFVBQUMsS0FBVSxFQUFFLE1BQXVCO1FBQ25ELElBQU0sSUFBSSxHQUFHLElBQUEsbUNBQWdCLEVBQUMsU0FBUyxFQUFFLEVBQUUsRUFBRSxNQUFNLENBQUMsQ0FBQztRQUNyRCxJQUFJLElBQUksRUFBRTtZQUNSLElBQU0sR0FBRyxHQUFHLEVBQUUsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUM7WUFDekIsSUFBSSxJQUFBLGlCQUFPLEVBQUMsR0FBRyxDQUFDLElBQUksSUFBQSxrQkFBUSxFQUFDLEdBQUcsQ0FBQyxFQUFFO2dCQUNqQyxPQUFPLEdBQUcsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUM7YUFDNUI7U0FDRjtJQUNILENBQUMsQ0FBQztJQUNGLElBQU0sTUFBTSxHQUFHLFVBQUMsTUFBdUI7UUFDckMsSUFBTSxJQUFJLEdBQUcsSUFBQSxtQ0FBZ0IsRUFBQyxTQUFTLEVBQUUsRUFBRSxFQUFFLE1BQU0sQ0FBQyxDQUFDO1FBQ3JELElBQUksSUFBSSxFQUFFO1lBQ1IsSUFBTSxHQUFHLEdBQUcsRUFBRSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUN6QixJQUFJLENBQUMsQ0FBQyxJQUFBLGtCQUFRLEVBQUMsR0FBRyxDQUFDLElBQUksSUFBQSxpQkFBTyxFQUFDLEdBQUcsQ0FBQyxJQUFJLElBQUEsb0JBQVUsRUFBQyxHQUFHLENBQUMsQ0FBQyxFQUFFO2dCQUN2RCxPQUFPO2FBQ1I7WUFDRCxPQUFPLEdBQUcsQ0FBQyxNQUFNLENBQUM7U0FDbkI7SUFDSCxDQUFDLENBQUM7SUFFRixJQUFNLFNBQVMsR0FBRztRQUNoQixLQUFLLE9BQUE7UUFDTCxRQUFRLFVBQUE7UUFDUixNQUFNLFFBQUE7UUFDTixhQUFhLEVBQUU7WUFDYixFQUFFLEVBQUUsSUFBQSx1QkFBUSxHQUFFO1lBQ2QsTUFBTSxFQUFFLDBCQUFrQjtZQUMxQixJQUFJLEVBQUUsRUFBRSxDQUFDLElBQUk7U0FDZDtLQUNGLENBQUM7SUFFRixPQUFPLFNBQVMsQ0FBQztBQUNuQixDQUFDLENBQUM7QUE1Q1csUUFBQSxZQUFZLGdCQTRDdkIifQ==